var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiniClipboardCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 8.75V4C2.25 3.44772 2.69772 3 3.25 3H8C8.55228 3 9 3.44772 9 4V8.75C9 9.30228 8.55229 9.75 8 9.75H3.25C2.69772 9.75 2.25 9.30229 2.25 8.75Z",
    stroke: "#0C5EFF",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 0.75H8.25C9.90685 0.75 11.25 2.09315 11.25 3.75V6",
    stroke: "#0C5EFF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniClipboardCopyIcon);
export default __webpack_public_path__ + "static/media/mini-clipboard-copy-icon.ff005dbe6f8a220d11e10f90272d55c8.svg";
export { ForwardRef as ReactComponent };